export default "__VITE_ASSET__c6f52ad3__"